<template>
  <div class="hero-container">
    <div class="top-bar">
      <img src="@/assets/titulos1.png" alt="HP y RM" class="logo-central" />
    </div>

    <div class="main-images">
      <img
        v-if="imagenPagina1"
        :src="imagenPagina1"
        class="img-home"
        @click="iniciarApp"
      />
      <span>Click en la foto para iniciar</span>
    </div>

    <div class="bottom-bar">
      <img src="@/assets/logosfooter.png" alt="HP y RM" class="logo-central" />
    </div>

    <!-- Indicador de estado IA -->
    <div
      class="ia-status-indicator"
      :class="iaStatus"
      :title="iaStatusLabel"
    ></div>

    <!-- Modal de estado -->
    <div v-if="showModal" class="modal-backdrop">
      <div class="modal-content">
        <p class="modal-message">
          {{ modalMessage }}
        </p>

        <div class="modal-actions" v-if="modalState === 'offline'">
          <button class="btn" @click="handleRetry">
            Reintentar
          </button>
          <button class="btn btn-secondary" @click="closeModal">
            Cerrar
          </button>
        </div>

        <div class="modal-actions" v-else>
          <button class="btn" @click="closeModal">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getImageFromDB, saveImageToDB } from '@/utils/indexedDbUtils'

const IA_STATUS_URL = 'https://flow.gestiontotal.app/webhook/comfyui/status'
const IA_STATUS_TOKEN =
  '628e54b8e81ae64f0f0be33335ad4a70559272187376444064ff245f4c8c3b7b'

export default {
  data() {
    return {
      imagenPagina1: null,

      // estados IA
      iaStatus: 'checking', // 'checking' | 'online' | 'offline'
      isChecking: false,

      // modal
      showModal: false,
      modalState: null, // 'checking' | 'offline' | 'error'
      modalMessage: '',
    }
  },
  computed: {
    iaStatusLabel() {
      switch (this.iaStatus) {
        case 'online':
          return 'Servidor de IA en línea'
        case 'offline':
          return 'Servidor de IA sin conexión'
        case 'checking':
        default:
          return 'Verificando conexión con el servidor de IA'
      }
    },
  },
  methods: {
    async cargarImagenDesdeDB() {
      const cacheKey = 'imagenpagina1'
      const cached = await getImageFromDB(cacheKey)

      if (cached) {
        this.imagenPagina1 = URL.createObjectURL(cached)
        return
      }

      const response = await fetch('/img/imagenpagina1.png') // ruta pública
      const blob = await response.blob()
      await saveImageToDB(cacheKey, blob)
      this.imagenPagina1 = URL.createObjectURL(blob)
    },

    async checkIAStatus() {
      this.isChecking = true
      this.iaStatus = 'checking'

      try {
        const response = await fetch(IA_STATUS_URL, {
          method: 'GET',
          headers: {
            'token-auth': IA_STATUS_TOKEN,
          },
        })

        if (!response.ok) {
          throw new Error('Error HTTP en verificación IA')
        }

        const data = await response.json()
        this.iaStatus = data && data.online ? 'online' : 'offline'
      } catch (error) {
        console.error('Error verificando IA:', error)
        // tratamos error como offline
        this.iaStatus = 'offline'
      } finally {
        this.isChecking = false
      }
    },

    iniciarApp() {
      // Si está online, pasamos a la siguiente vista
      if (this.iaStatus === 'online') {
        this.$router.push('/seleccion-genero')
        return
      }

      // Si está verificando (gris)
      if (this.iaStatus === 'checking' || this.isChecking) {
        this.modalState = 'checking'
        this.modalMessage =
          'Se está verificando la conexión con el servidor de IA, espere un momento.'
        this.showModal = true
        return
      }

      // Si está offline (rojo)
      if (this.iaStatus === 'offline') {
        this.modalState = 'offline'
        this.modalMessage =
          'No se ha podido verificar la conexión con el servidor de IA. ¿Quieres intentar de nuevo?'
        this.showModal = true
      }
    },

    closeModal() {
      this.showModal = false
    },

    async handleRetry() {
      // Cierra modal, reintenta, y en base al resultado decide qué hacer
      this.showModal = false
      await this.checkIAStatus()

      if (this.iaStatus === 'online') {
        // Todo ok; el usuario ya puede dar click de nuevo para iniciar.
        return
      }

      // Sigue offline: mensaje definitivo
      this.modalState = 'error'
      this.modalMessage =
        'No se ha podido realizar la conexión con el servidor de IA. Contacte con TI para resolver la situación.'
      this.showModal = true
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch('generateTokens')
      await this.cargarImagenDesdeDB()
      // lanzamos la verificación de IA
      this.checkIAStatus()
    } catch (error) {
      alert('Error al preparar la app. Intente nuevamente.')
    }
  },
}
</script>

<style lang="scss" scoped>
.hero-container {
  background: linear-gradient(to right, #48465c 0%, #211f2e 50%, #151d2b 100%);
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  font-family: 'FormaDJRDisplay', sans-serif;
  overflow: hidden;
  position: relative;
}

.top-bar {
  display: flex;
  color: white;
}

.textos {
  flex: 1;
  .header {
    display: flex;
    padding: 0 2rem 0 2rem;
    justify-content: space-between;
  }
  .titulo {
    font-size: 6rem;
    max-width: 800px;
    letter-spacing: 3px;
    text-align: left;
    margin: 0;
    line-height: 1;
  }

  .linea-subtitulo {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 0.5rem;
    gap: 1rem;
    text-align: left;

    hr {
      flex: 1;
      border: none;
      min-height: 1px;
      min-width: 100%;
      background-color: white;
    }

    p {
      margin: 0;
      font-size: 2rem;
      white-space: nowrap;
      letter-spacing: 1px;
      width: 100%;
      line-height: 0.5;
      padding: 0 2rem;
    }
  }
}

.logo-central {
  width: 100%;
}

.main-images {
  text-align: left;

  img {
    width: 100%;
    margin-top: 5vh;
    cursor: pointer;
  }

  span {
    color: #fff;
    margin-left: 2vw;
    letter-spacing: 1px;
  }
}

.bottom-bar {
  text-align: center;
  width: 100%;
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: flex-end;

  img {
    max-width: 40vw;
  }
}

/* Indicador de estado IA */
.ia-status-indicator {
  position: fixed;
  bottom: 16px;
  right: 16px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.4);
}

/* gris - verificando */
.ia-status-indicator.checking {
  background-color: #9e9e9e;
}

/* verde - online */
.ia-status-indicator.online {
  background-color: #4caf50;
}

/* rojo - offline */
.ia-status-indicator.offline {
  background-color: #f44336;
}

/* Modal simple */
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
}

.modal-content {
  background: #1f2430;
  color: #ffffff;
  padding: 1.5rem 2rem;
  border-radius: 10px;
  max-width: 420px;
  width: 90%;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.45);
  text-align: center;
}

.modal-message {
  margin-bottom: 1.5rem;
  font-size: 0.95rem;
  line-height: 1.4;
}

.modal-actions {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
}

.btn {
  padding: 0.45rem 1.2rem;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  font-size: 0.85rem;
  letter-spacing: 0.03em;
  background: #00bcd4;
  color: #ffffff;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}

.btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0, 188, 212, 0.45);
}

.btn-secondary {
  background: #424242;
}

.btn-secondary:hover {
  box-shadow: 0 4px 10px rgba(66, 66, 66, 0.45);
}

.start-linea {
  display: flex;
  align-items: center;

  hr {
    flex: 1;
    border: none;
    height: 1px;
    background-color: white;
  }

  .start-button {
    background-color: transparent;
    color: white;
    font-size: 1.1rem;
    border: none;
    display: block;
    width: 100%;
    padding: 1rem 2rem;
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
    letter-spacing: 1px;

    &:hover {
      background-color: white;
      color: #0095d9;
    }
  }
}
</style>
